import get from "lodash/get";
import logCalls from "shared/util/logCalls";
import { isDev } from "shared/util/EnvironmentHelpers";

class Context {
	static data = {};

	static init(data) {
		this.data = data;
	}

	static get(key) {
		if (!this.data) {
			return null;
		}

		return get(this.data, key);
	}

	static has(key) {
		if (!this.data) {
			return null;
		}

		return !!get(this.data, `state.${key}`);
	}

	static getSetting(key) {
		if (!this.data) {
			return null;
		}

		return get(this.data, `settings.${key}`);
	}

	static getUserDemo(key) {
		if (!this.data) {
			return null;
		}

		return get(this.data, `user_demo.${key}`);
	}

	static hasPremium(key) {
		if (!this.data) {
			return false;
		}

		return !!get(this.data, `premiums.${key}`);
	}
}

// Used for backwards compat with non-SPA code (AKA: most code).
if (window.Context) {
	// Init new Context.
	Context.init(window.Context.data || {});

	// Log calls to the old Context.
	// Maybe make this a stat count at some point.
	if (isDev) {
		logCalls(window.Context, ({ name, args }) => {
			console.warn(`Called Context.${name}`, args);
		});
	}
} else {
	window.Context = Context;
}

export default Context;



// WEBPACK FOOTER //
// ./src/shared/util/Context.js